import * as types from './actionTypes';

const initialState = {
  fixedDeduction: null,
  deductionList:[],
  loading: false,
  error: null,
  success: false,
};

const fixedDeductionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.PAYROLL_DEDUCTION_FETCH_FIXED_DEDUCTION:
    case types.PAYROLL_DEDUCTION_SAVE_FIXED_DEDUCTION:
    case types.PAYROLL_DEDUCTION_CHANGE_FIXED_DEDUCTION_STATUS:
    case types.PAYROLL_DEDUCTION_REMOVE_FIXED_DEDUCTION:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case types.PAYROLL_DEDUCTION_FETCH_FIXED_DEDUCTION_SUCCESS:
      return {
        ...state,
        //fixedDeduction: action.payload?.data,
        loading: false,
        success: true,
        fixedDeduction: (action.payload?.data).map(ded => ({
          enable_status: true,
          entry_type: 1,              
          ded_id:0,
          emp_code:ded.emp_no,
          emp_no: {value:ded.emp_id,label:ded.emp_no+' - '+ded.emp_name},          
          emp_id: ded.emp_id,
          emp_name: ded.emp_name,
          amount: ded.amount,
          monthly_ded_id: ded.monthly_ded_id,         
          remarks: ded.remarks
        })),
      };

    case types.PAYROLL_DEDUCTION_SAVE_FIXED_DEDUCTION_SUCCESS:
       return {
        ...state,
        loading: false,
        success: true,        
      };
    case types.PAYROLL_DEDUCTION_REMOVE_FIXED_DEDUCTION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,        
      };
    case types.PAYROLL_DEDUCTION_CHANGE_FIXED_DEDUCTION_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true
      };

    case types.PAYROLL_DEDUCTION_FETCH_FIXED_DEDUCTION_FAILURE:
    case types.PAYROLL_DEDUCTION_SAVE_FIXED_DEDUCTION_FAILURE:
    case types.PAYROLL_DEDUCTION_CHANGE_FIXED_DEDUCTION_STATUS_FAILURE:
    case types.PAYROLL_DEDUCTION_REMOVE_FIXED_DEDUCTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case types.PAYROLL_DEDUCTION_FETCH_DROPDOWN_DEDUCTION:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case types.PAYROLL_DEDUCTION_FETCH_DROPDOWN_DEDUCTION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: false,
        deductionList: (action.payload?.data).map(ded => ({
          value: ded.pay_ded_id,
          label: ded.short_name
        })),
      };
  case types.PAYROLL_DEDUCTION_FETCH_DROPDOWN_DEDUCTION_FAILURE:
    return {
      ...state,
      loading: false,
      success: false,
      error: action.payload,
    };

    case types.PAYROLL_DEDUCTION_FIXED_TEMPLATE:
    case types.PAYROLL_DEDUCTION_FIXED_TEMPLATE_SUCCESS:
      return { ...state, loading: false, success: false, template: action.payload };
    case types.PAYROLL_DEDUCTION_FIXED_TEMPLATE_FAILURE:

    case types.PAYROLL_DEDUCTION_FIXED_IMPORT:
    case types.PAYROLL_DEDUCTION_FIXED_IMPORT_SUCCESS:
      return { ...state, loading: false, success: false, importedData: action.payload?.data || [] };
    case types.PAYROLL_DEDUCTION_FIXED_IMPORT_FAILURE:

    default:
      return state;
  }
};

export default fixedDeductionReducer;
